module.exports = __webpack_public_path__ + "img/app_store.8c15379d.svg";